<template>
  <!-- 正常点击进入 -->
  <div class="margin-left">
    <firm :firm="firm" @toSet="toSet"></firm>
    <!--  -->
    <div class="contentWhole">


      <!-- 修改供应人资料 -->
      <div class="setSupply" v-if="isSetLinkMain">
        <!-- 内容 -->
        <div class="setContent">
          <div class="flex-col section_5 space-y-91">
            <div class="flex-col">
              <div class="flex-col justify-start items-start text-wrapper_4">
                <span class="font_6 text_22">您正在修改供应人资料</span>
              </div>
              <div class="flex-row justify-center items-center group_11 space-x-28">
                <div class="flex-col items-center space-y-53">
                  <span class="font_7">联系姓名</span>
                  <span class="font_9">联系方式</span>
                </div>
                <div class="flex-col space-y-16">
                  <input class="flex-col justify-start items-start text-wrapper_5" placeholder="请输入姓名"
                    v-model="changeLinkMan">



                  <div style="position: relative;">
                    <input class="flex-col justify-start items-start text-wrapper_5" placeholder="请输联系方式"
                      v-model="changePhone" @blur="phoneverFun" @input="numInput">
                    <div v-if="isPhone" class="errPhone">请输入正确格式的手机号</div>
                  </div>



                </div>
              </div>
            </div>
            <div class="flex-col items-center space-y-28">
              <div class="flex-col justify-start items-center text-wrapper_6" @click="linkManSubmit"><span
                  class="text_26">保存提交</span></div>
              <div class="group_12">
                <span class="font_9 text_27">如有疑问请联系平台客服：</span>
                <span class="text_28">400-212-22</span>
              </div>
            </div>
          </div>
        </div>



      </div>



      <!-- 公司简介与产品列表 -->
      <div v-else>
        <div class="contentTab flexItem flexB">
          <div class="left flexItem">
            <div :class="index==tabIndex?'leftTab flexCenter tabActive':'leftTab flexCenter'"
              v-for="(item,index) in tab" @click="tabFun(index)">{{item.name}}</div>
          </div>

          <div class="right flexItem" @click="toSetFun" v-show="!isSave">
            <img src="../../../assets/img/toRight.png" class="rightIcon">
            <div class="rightText">{{tab[tabIndex].fun}}</div>
          </div>
          <!-- 点击“编辑简介”后 -->
          <div class="right flexItem" @click="saveFun" v-show="isSave">
            <img src="../../../assets/img/toRight.png" class="rightIcon">
            <div class="rightText">保存编辑</div>
          </div>
        </div>


        <div class="firmContent" :style="backStyle">
          <!-- 公司简介 -->
          <div v-show="tabIndex==0 && !isSetDes">
            <div v-html="firm.content"></div>
            <img :src="firm.logo" class="firmLogo" v-if="firm.logo">
          </div>

          <!-- 修改编辑公司简介 -->
          <div class="setFirm" v-if="isSetDes && tabIndex==0">
            <textarea class="textInput" placeholder="请输入公司介绍" v-model="changeContent"></textarea>

            <el-upload class="avatar-uploader" action="https://manage.ciiply.com/api/pc/user/upFile"
              :show-file-list="false" :on-success="handleAvatarSuccess">
              <img v-if="imageUrl" :src="imageUrl" class="avatar">
              <div class="upTextBox" v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="upText1">上传图片</div>
                <div class="upText2">建议尺寸：860*410</div>
              </div>

            </el-upload>
          </div>

          <!-- 产品列表 -->
          <div class="proList" v-show="tabIndex==1">
            <div class="proListItem flexItem flexB" v-for="(item,index) in proList" :key="item.id">
              <div class="flexItem">
                <img :src="item.logo" class="proItemImg">
                <div class="info">
                  <div class="proInfoTitle">
                    {{item.name}}
                  </div>

                  <div class="proInfoText">
                    起批：{{item.start_name}}
                  </div>

                  <div class="proInfoMoney">
                    {{item.price}}元/{{item.spec}}
                  </div>
                </div>
              </div>

              <!-- 功能区域 -->
              <div class="funBox flex">
                <div class="proDel flexItem" @click="delGoodsFun(item.id,index)">
                  <img src="../../../assets/img/lese.png" class="proDelIcon">
                  删除
                </div>
                <div class="proButton flexCenter" @click="editFun(index)">
                  编辑
                </div>
                <!-- <div class="proRen">
                  {{item.ren}}人已购买
                </div> -->
              </div>
            </div>

            <div class="pagination flexCenter">
            	<el-pagination
            	@current-change="handleCurrentChange"
            	  background
            	  layout="prev, pager, next"
            	  prev-text="上一页"
            	  next-text="下一页"
            	  :total="total"
                :page-size="10"
                hide-on-single-page
                >
            	</el-pagination>
            </div>
          </div>
        </div>
      </div>



    </div>
  </div>

</template>

<script>
  import firm from "./firm.vue";
  // import {regPhone} from "@/src/assets/js/reg.js";
  import {
    regPhone
  } from "../../../../src/assets/js/reg.js";
  import {mapState} from "vuex";
  export default {
    data() {
      return {
        total:0,//产品数据总数
        pageIndex:1,//当前页数
        backStyle: 'background:#FFF;margin-top:20px;', //额外样式
        isSave: false, //是否正在编辑简介
        imageUrl: '', //公司简介图片
        isPhone: false, //手机号错误信息
        isSetDes: false, //是否显示修改简介信息
        isSetLinkMain: false, //是否显示修改平台信息
        changePhone: '', //当前输入手机号
        changeLinkMan: '', //当前输入联系人姓名
        changeContent: '', //当前输入公司简介
        firm: {}, //平台信息+公司简介
        tab: [{
            name: "企业介绍",
            fun: '编辑介绍'
          },
          {
            name: "产品管理",
            fun: '发布产品'
          }
        ],
        tabIndex: 0,//当前选中tab项
        proList: [{
            title: '工地活动集装箱房',
            num: '1000个',
            money: '100.00元/个',
            ren: '3650',
            imgSrc: ''
          },
          {
            title: '工地活动集装箱房',
            num: '1000个',
            money: '100.00元/个',
            ren: '3650',
            imgSrc: ''
          },
          {
            title: '工地活动集装箱房',
            num: '1000个',
            money: '100.00元/个',
            ren: '3650',
            imgSrc: ''
          }
        ]
      }
    },
    computed:{
      ...mapState(['isBack'])
    },
    created() {
      // 获取公司信息
      this.getFirmInfo();
      // 获取产品列表
      this.getGoodsList(1);
      // 当前如果是发布页跳转回来的,那就直接显示列表，并给于对应样式
      if(this.isBack){
        this.tabIndex = 1;
        this.backStyle = 'background:transparent;margin-top:0px;';
      }
    },
    methods: {
      // 分页函数
      handleCurrentChange(currentPage) {
        this.pageIndex = currentPage;
        this.getGoodsList(this.pageIndex);
      },
      // 去编辑
      editFun(index){
        // 使用vuex
        this.$store.commit('setSupplyAdd',this.proList[index]);
        // 跳转产品编辑
        this.$emit('gettype', {
          type: 'sendgoods',
          typeone: ''
        })
      },
      // 删除产品
      delGoodsFun(id,index) {
        this.$confirm('此操作将永久删除该产品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error'
        }).then(() => {
          this.delGoods(id,index);
        })


      },
      // 保存企业简介
      saveFun() {
        this.ajax('post', '/api/pc/userReal/editCompanyInfo', {
          id: this.firm.id,
          content: this.changeContent,
          logo: this.imageUrl
        }, res => {
          if (res.status == 200) {
            this.firm.logo = this.imageUrl;
            this.firm.content = this.changeContent;
            this.isSave = false;
            this.isSetDes = false;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 上传图片显示
      handleAvatarSuccess(file) {
        this.imageUrl = file.data.url;
      },
      // 切换tab栏选项
      tabFun(index) {
        if (index == 0) {
          this.backStyle = 'background:#FFF;margin-top:20px;';
        } else {
          this.backStyle = 'background:transparent;margin-top:0px;';
        }
        if (index != 0) {
          this.isSave = false;
          this.isSetDes = false;
        }
        this.tabIndex = index;
      },
      // 修改联系人信息
      toSet(e) {
        /* this.$emit('gettype',{type:e,typeone:''})
         */
        this.changeLinkMan = this.firm.user_name;
        this.changePhone = this.firm.user_phone;
        this.isSetLinkMain = true;
      },
      // 提交修改联系人
      linkManSubmit() {
        if (!regPhone(this.changePhone)) {
          // 未通过正则
          this.isPhone = true;
          return false;
        }
        // 修改联系人
        this.ajax('post', '/api/pc/userReal/editCompanyInfo', {
          id: this.firm.id,
          user_name: this.changeLinkMan,
          user_phone: this.changePhone
        }, res => {
          if (res.status == 200) {
            this.firm.user_name = this.changeLinkMan;
            this.firm.user_phone = this.changePhone;
            this.isSetLinkMain = false;
          } else {
            this.$message.error(res.msg);
          }
        })


      },
      // 修改公司简介或跳转产品编辑
      toSetFun() {
        if (this.tabIndex == 0) {
          // 公司简介编辑
          this.imageUrl = this.firm.logo;
          // console.log(this.firm.content)
          this.changeContent = this.firm.content.replace(/<[^>]+>/g, '');
          this.isSetDes = true;
          this.isSave = true;

        } else {
          // 跳转产品编辑
          this.$emit('gettype', {
            type: 'sendgoods',
            typeone: ''
          })
        }
      },
      // 验证手机号
      phoneverFun() {
        if (!regPhone(this.changePhone)) {
          // 未通过正则
          this.isPhone = true;
        } else {
          this.isPhone = false;
        }
      },
      // 输入手机号时验证只能输入数字
      numInput(e) {
        let o = e.target;
        let inputRule = /[^\d]/g;
        this.$nextTick(function() {
          this.changePhone = o.value.replace(inputRule, '');
        })
      },
      // 获取企业信息
      getFirmInfo() {
        this.ajax('get', '/api/pc/userReal/getCompany', {}, res => {
          if (res.data.code == 202) {
            this.$message.error('当前没有企业认证，请先进行企业认证');
            // 跳转产品编辑
            this.$emit('gettype', {
              type: 'enterprise',
              typeone: ''
            });
            // 改变侧边栏颜色
            this.$emit('leftFun', 6)
          }
          this.firm = res.data;
        })
      },

      // 获取产品列表
      getGoodsList(page) {
        this.ajax('get', '/api/pc/goods/getCompanyGoods', {
          page
        }, res => {
          // 当页数为1时,来计算总页数
          if(this.pageIndex == 1){
          	this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
          }

          this.proList = res.data.data;
        })
      },
      // 删除产品
      delGoods(id,index) {
        this.ajax('post', '/api/pc/goods/deleteGoods', {
          id
        }, res => {
          if(res.data.code==200){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            // 在pc端由于有分页器的原因,因此删除就必须重新请求数据进行渲染，以保证分页正常
            // this.proList.splice(index,1);
            this.getGoodsList(this.pageIndex);
          }
        })
      }

    },
    beforeDestroy: function() {
      // 在退出这个组件的时候把vuex中的后退判断依据改回原样
      this.$store.commit('isBackFun',false);
    },
    components: {
      firm
    }
  }
</script>

<style scoped>
  @import url('./adminSupply.css');
</style>



// WEBPACK FOOTER //
// src/components/my/supply/adminSupply.vue